import { CLASSES } from '../utils/constants';
import { toggleHtmlClass } from '../utils/domHelpers';

export function applyCursor(enabled, isExtraLarge) {
  document.documentElement.classList.remove(CLASSES.largeCursor, CLASSES.extraLargeCursor);
  if (enabled) {
    toggleHtmlClass(isExtraLarge ? CLASSES.extraLargeCursor : CLASSES.largeCursor, true);
  }
}
